var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentsMenuIconHoverV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74074 13.1218C4.74074 13.4491 4.47543 13.7144 4.14815 13.7144C3.82087 13.7144 3.55556 13.4491 3.55556 13.1218L3.55556 9.62767C3.55556 8.56532 4.41791 7.7037 5.47998 7.7037H11.3101C12.3728 7.7037 13.2346 8.56539 13.2346 9.62767V13.1218C13.2346 13.4491 12.9693 13.7144 12.642 13.7144C12.3147 13.7144 12.0494 13.4491 12.0494 13.1218V9.62767C12.0494 9.21997 11.7183 8.88889 11.3101 8.88889H5.47998C5.07224 8.88889 4.74074 9.22011 4.74074 9.62767V13.1218Z",
    fill: "#3537E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62962 4.29629C5.62962 5.68723 6.7572 6.81481 8.14814 6.81481C8.84505 6.81481 9.49789 6.52954 9.96969 6.03552C10.4139 5.57043 10.6667 4.95246 10.6667 4.29629C10.6667 2.90535 9.53908 1.77777 8.14814 1.77777C6.7572 1.77777 5.62962 2.90535 5.62962 4.29629ZM9.11258 5.21696C8.86216 5.47918 8.51788 5.62962 8.14814 5.62962C7.41176 5.62962 6.81481 5.03267 6.81481 4.29629C6.81481 3.55991 7.41176 2.96296 8.14814 2.96296C8.88452 2.96296 9.48148 3.55991 9.48148 4.29629C9.48148 4.64449 9.34822 4.97022 9.11258 5.21696Z",
    fill: "#3537E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2963 10.3704C7.96902 10.3704 7.7037 10.1051 7.7037 9.77777C7.7037 9.45049 7.96902 9.18518 8.2963 9.18518C8.62358 9.18518 8.88889 9.45049 8.88889 9.77777C8.88889 10.1051 8.62358 10.3704 8.2963 10.3704Z",
    fill: "#3537E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 13.037C8.88889 13.3643 8.62358 13.6296 8.2963 13.6296C7.96902 13.6296 7.7037 13.3643 7.7037 13.037V11.2593C7.7037 10.932 7.96902 10.6667 8.2963 10.6667C8.62358 10.6667 8.88889 10.932 8.88889 11.2593V13.037Z",
    fill: "#3537E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentsMenuIconHoverV4);
export default __webpack_public_path__ + "static/media/agents-menu-icon-hover-v4.e1179f71cc4bf9460fe7e0f23f085878.svg";
export { ForwardRef as ReactComponent };